/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = $('.permission-tree :checkbox');

    permissionTree.on('click change', function (){
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });
	
	function getDataArray (localeJquery)  {
		var localeJquery = $('html').attr('lang');
		var dataArray = [];
		
		switch(localeJquery) {
			case 'en':
				dataArray['title_1_text'] = 'Are you sure you want to delete this item?';
				dataArray['title_2_text'] = 'Are you sure you want to do this?';
				dataArray['confirm_delete_text'] = 'Confirm Delete';
				dataArray['cancel_text'] = 'Cancel';
				dataArray['continue_text'] = 'Continue';
				break;
			case 'zh':
				dataArray['title_1_text'] = '你确定要删除这个项目吗?';
				dataArray['title_2_text'] = '你确定你要这么做吗?';
				dataArray['confirm_delete_text'] = '确认删除';
				dataArray['cancel_text'] = '取消';
				dataArray['continue_text'] = '继续';
				break;
			case 'zh-TW':
				dataArray['title_1_text'] = '你確定要刪除這個項目嗎?';
				dataArray['title_2_text'] = '你確定你要這麼做嗎?';
				dataArray['confirm_delete_text'] = '確認刪除';
				dataArray['cancel_text'] = '取消';
				dataArray['continue_text'] = '繼續';
				break;
		  default:
				dataArray['title_1_text'] = 'Are you sure you want to delete this item?';
				dataArray['title_2_text'] = 'Are you sure you want to do this?';
				dataArray['confirm_delete_text'] = 'Confirm Delete';
				dataArray['cancel_text'] = 'Cancel';
				dataArray['continue_text'] = 'Continue';
		}
		
		return dataArray;
	}

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function(e) {
        e.preventDefault();
		
		var localeJquery = $('html').attr('lang');
		var dataArray = getDataArray(localeJquery);
	
        Swal.fire({
            title: dataArray['title_1_text'],
            showCancelButton: true,
            confirmButtonText: dataArray['confirm_delete_text'],
            cancelButtonText: dataArray['cancel_text'],
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();
			
			var localeJquery = $('html').attr('lang');
			var dataArray = getDataArray(localeJquery);

            Swal.fire({
                title: dataArray['title_2_text'],
                showCancelButton: true,
                confirmButtonText: dataArray['continue_text'],
                cancelButtonText: dataArray['cancel_text'],
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();
		
		var localeJquery = $('html').attr('lang');
		var dataArray = getDataArray(localeJquery);
	
        Swal.fire({
            title: dataArray['title_2_text'],
            showCancelButton: true,
            confirmButtonText: dataArray['continue_text'],
            cancelButtonText: dataArray['cancel_text'],
            icon: 'info',
        }).then((result) => {
            result.value && window.location.assign($(this).attr('href'));
        });
    });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="'+hash+'"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();
});
